import { environment } from './../environments/environment';
import { Component } from '@angular/core';
@Component({
  selector: 'mlcint-root',
  templateUrl: './app.component.html',
  styleUrls: ['./corner-ribbons.scss'],
})
export class AppComponent {
  devEnvironment = !environment.production && !environment.demo;
  demoEnvironment = environment.demo;
  title = 'OrganizeMED: MESH';
}
